import React, { useEffect } from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  title,
  message,
  successMessage,
  errorMessage,
  onClose,
  onConfirm,
  type,
}) => {
  // Handle ESC and Enter key events
  useEffect(() => {
    if (isOpen) {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") {
          onClose?.(); // Close modal on ESC
        } else if (e.key === "Enter" && type === "confirm") {
          onConfirm?.(); // Confirm action on Enter
        }
      };

      document.addEventListener("keydown", handleKeyDown);

      // Cleanup listener when modal is closed
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, onClose, onConfirm, type]);

  if (!isOpen) return null; // Return null if modal is not open

   // Determine the modal title dynamically
   const modalTitle =
   title ||
   (type === "confirm"
     ? "Are you sure?"
     : type === "success"
     ? "Success!"
     : type === "error"
     ? "Error!"
     : "Notification");

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{modalTitle}</h2>
        <p>{message || successMessage || errorMessage}</p>
        <div className="modal-actions">
          {type === "confirm" && (
            <>
              <button onClick={onClose} className="modal-button modal-cancel">
                Cancel
              </button>
              <button onClick={onConfirm} className="modal-button modal-confirm">
                Confirm
              </button>
            </>
          )}
          {(type === "success" || type === "error") && (
            <button onClick={onClose} className="modal-button modal-close">
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
